import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Divider, Row, Typography} from "antd";
import {compose} from "redux";
import {canUpdate} from "../../Boilerplate/permissions";
import {DailyLogFiles} from "./DailyLogFiles";
import ChatWall from "../../Boilerplate/ChatWall";
import {CodeTag} from "../../Boilerplate/CodeTag";
import {compArr} from "../selectors";
import DateTimeDisplay from "../../Boilerplate/DateTimeDisplay";
import UserSmall from "../../Boilerplate/UserSmall";

const DailyLogDetail = ({ dailyLog, projectId, onEdit }) => {
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth - keyWidth;
  return (
    <Row gutter={24}>
      <Col span={17}>
        <Row type='flex' gutter={24}>
          <Col className='bid-dashboard-info' span={12}>
            <Card
              className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'
              title={<span>
            Daily Log #{dailyLog.resource.number} - <DateDisplay date={dailyLog.resource.logdate}/>
          </span>}
              extra={
                <Button.Group>
                  <Button key='1' icon='edit' onClick={onEdit} disabled={!canUpdate(dailyLog)}>Edit</Button>
                </Button.Group>
              }
            >
              <Divider>Daily Summary</Divider>
              <p className='formatted-text'>{dailyLog.resource.summary}</p>
              {dailyLog.resource.weather && <p>Weather info: <span
                className='formatted-text'>{dailyLog.resource.weather}</span><br/></p>}
              {dailyLog.resource.templo && dailyLog.resource.temphi &&
              <p>Temperatures ranged from {dailyLog.resource.templo}°F
                to {dailyLog.resource.temphi}°F</p>}
              <p>Created on <DateTimeDisplay date={dailyLog.resource.datecreated}/> by <UserSmall id={dailyLog.resource.createdbyuserid}/></p>
            </Card>
          </Col>
          <Col className='bid-dashboard-info' span={12}>
            <Card className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card' title='Details'>
              <Divider>Issues & Delays</Divider>
              <Row className='key-value'>
                <Col span={keyWidth}>Safety Issues</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.safetyissues || <Typography.Text type='secondary'>No safety issues reported.</Typography.Text>}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Weather Delays</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.weatherdelays || <Typography.Text type='secondary'>No weather delays reported.</Typography.Text>}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Trade Delays</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.tradedelays || <Typography.Text type='secondary'>No trade delays reported.</Typography.Text>}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Safety Delays</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.safetydelays || <Typography.Text type='secondary'>No safety delays reported.</Typography.Text>}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Other Delays</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.otherdelays || <Typography.Text type='secondary'>No other delays reported.</Typography.Text>}</Col>
              </Row>
              <Divider>Additional Information</Divider>
              <Row className='key-value'>
                <Col span={keyWidth}>Visitors</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.visitors || <Typography.Text type='secondary'>No visitors reported.</Typography.Text>}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Subcontractors</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.subcontractors || <Typography.Text type='secondary'>No subcontractors reported.</Typography.Text>}</Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Equipment</Col>
                <Col span={valWidth} className='formatted-text'>{dailyLog.resource.equipment || <Typography.Text type='secondary'>No equipment reported.</Typography.Text>}</Col>
              </Row>
              <Divider>CSI Codes</Divider>
              <div>
                {dailyLog.resource.csicodes && dailyLog.resource.csicodes.map(code => (
                  <CodeTag table='csi' key={code} code={code}/>
                ))}
              </div>
            </Card>
          </Col>
        </Row>
        <DailyLogFiles/>
      </Col>
      <Col span={7}>
        <ChatWall projectId={projectId} dailyLogId={dailyLog.resource.id}/>
        {/*<Activity/>*/}
      </Col>
    </Row>
  );
};

export default compose(
  connect(
    (state, props) => {
      let projectId = props.match.params.id;
      let dailyLog = state.view.subview.data[props.match.params.dailyLogId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'dailylogs', props.match.params.dailyLogId];
      if (!compArr(path, itempath) || loading || !dailyLog) return { loading: true };
      return { dailyLog, projectId };
    },
    (dispatch, props) => ({
      onEdit: () => props.history.push(`/projects/${props.match.params.id}/daily-logs/${props.match.params.dailyLogId}/edit`)
    })
  ),
)(DailyLogDetail);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogDetail.js